<ng-sidebar-container>
  <div ng-sidebar-content>
    <ngx-page-container>
      <h1>Project Overview</h1>
      <hr>


      <div style="margin-left:1em;min-width:35em">
        <label><b>Filter</b></label>
        <div class="row ml-1">
          <div style="width:25em">
            <ngx-doc-form-multiselect [(value)]="filter.issuer" [options]="issuerOptions" [multi]="false" placeholder="Select Issuer(s)"></ngx-doc-form-multiselect>
            <ngx-doc-form-multiselect [(value)]="filter.country" [options]="countryOptions" placeholder="Select Country"></ngx-doc-form-multiselect>
            <ngx-doc-form-multiselect [(value)]="filter.manager" [options]="employeeOptions" [multi]="false" placeholder="Select Manager"></ngx-doc-form-multiselect>
          </div>
          <div style="width: 42em">
            <ngx-doc-form-multiselect [(value)]="filter.customers" [options]="data.businessOptions" (valueChange)="customersChanged($event)"
              [checkbox]="true" [maxSelectedItems]="3" placeholder="Select customer(s)">
            </ngx-doc-form-multiselect>
            <ngx-doc-form-multiselect *ngIf="filter.customers?.length" [(value)]="filter.customerDocumentNumbers" [checkbox]="true"
              [options]="customerReferenceOptions" placeholder="Customer reference(s)">
            </ngx-doc-form-multiselect>

            <ngx-doc-form-multiselect *ngIf="filter.businessUnits" [(value)]="filter.businessUnits" [options]="data.businessUnitOptions"
              [checkbox]="true" placeholder="Select business unit(s)">
            </ngx-doc-form-multiselect>

            <div class="row" style="margin:2pt;">
              <div style="padding:4pt">Project Number:</div>
              <div style="width:75%"><ngx-form-text [(value)]="filter.projectNumber"></ngx-form-text></div>
            </div>
          </div>
        </div>

        <div class="mt-4" style="max-width:57em">
          <ngx-form-multi-select [checkbox]="true" title="Select Finished Products" [businessId]="finishedProductBusinessId" [mode]="'column-select'" [(value)]="filter.finishedProducts" [options]="data.finishedProductOptions">
          </ngx-form-multi-select>
        </div>

        <div class="mt-4" style="max-width:57em">
          <ngx-doc-form-filter-select title="Sort By" [noBorder]="true" [(value)]="filter.sortDate" [options]="datesData.getProjectOverviewOptions()"></ngx-doc-form-filter-select>
        </div>

      </div>

      <br><br>

      <div class="row">
        <div class="col-md-4">Variant</div>
        <div class="col-md-8">
          <nb-radio-group name="ocmachinery" class="row col-md-8" [(ngModel)]="filter.variant">
            <!-- <nb-radio [value]="null" checked>Standard View</nb-radio> -->
            <nb-radio [value]="401">OC Machinery by Manager</nb-radio>
            <nb-radio [value]="402">OC Machinery</nb-radio>
          </nb-radio-group>
        </div>
      </div>

      <!-- <div class="row">
        <div class="col-md-4"></div>
        <div class="col-md-8 row">
          <div class="ml-3"><ngx-doc-form-checkbox [(value)]="filter.projectOverview"></ngx-doc-form-checkbox></div>
          <div>change for project overview</div>
        </div>
      </div> -->

      <br>
      <div>
        <button class="btn btn-info btn-lg" (click)="reload()">Apply Filter</button>
      </div>
      <br>

      <ngx-reports-printer #reportsPrinter *ngIf="search" [search]="search" [pdfSidebar]="true" [printCount]="true" [messaging]="true" [noheader]="true" (done)="reportLoaded()"></ngx-reports-printer>

    </ngx-page-container>
  </div>
</ng-sidebar-container>

